module.exports = __webpack_public_path__ + "assets/images/earn-rewards/user-example-1.6b71b839644f97856afb1aceab9fcf6b.webp";